import type { JSX, PropsWithChildren } from 'react';

import { PayPalScriptProvider } from '@paypal/react-paypal-js';

import { isLoaded } from 'src/app/shared/utils/async';

import { PaypalContext } from './context';
import { usePaypalState } from './usePaypalState';

export function PaypalProvider({ children }: PropsWithChildren<EmptyProps>): JSX.Element {
	const state = usePaypalState();

	// Only wrap with PayPalScriptProvider once we have the clientToken in paypalState
	if (isLoaded(state)) {
		return (
			<PaypalContext.Provider value={state}>
				<PayPalScriptProvider
					deferLoading
					options={{
						// clientId is required by the type, but it’s not actually used in
						// our setup (PayPal via Braintree). What we really need is dataClientToken.
						// This value is just a dummy to satisfy TypeScript.
						clientId: 'test',
						components: 'buttons',
						dataClientToken: state.clientToken,
					}}
				>
					{children}
				</PayPalScriptProvider>
			</PaypalContext.Provider>
		);
	}

	// Before clientToken is ready, render without PayPalScriptProvider
	// which will show loading state since paypalState is not loaded yet
	return <PaypalContext.Provider value={state}>{children}</PaypalContext.Provider>;
}
